import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.div<{ error?: boolean }>(props => ({
    color: props.error ? theme(props).semanticColors.danger.color : undefined,
}));
